import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal } from 'antd';
import styles from './index.module.css';
import { useCreateRideHandlers } from '../../../hooks/useCreateRideHandlers';
import { Navigation } from '../../../utils/navigation';
import { useSelector } from 'react-redux';
import { MANDATORY_LEVEL, RIDE_REQUEST_FIELDS, URLS } from '../../../constants/constants';
import { connect } from 'react-redux';
import { setCurrentStep, saveDraft } from '../../../store/drafts';
import { getPlatformSettings, getAdditionalRideOptions } from '../../../store/preferences';
import { fetchHOPreferences } from '../../../store/health_organizations';
import QuickSchedule from './quickSchedule';
import { bindActionCreators } from 'redux';
import { transformRideRequestFields } from '../../../utils';
import { isEqual } from 'lodash';

export const QuickScheduleModal = ({
  visibleModal,
  setModalVisible,
  step,
  draftId,
  airportBufferTime,
  draft,
  riderDetails,
  getPlatformSettings,
  platformPreferences,
  defaultTimeZone,
  fetchHOPreferences,
  HOPreferences,
  getAdditionalRideOptions,
}) => {
  const viewDashboardMode = useSelector((state) => state.authorization.viewDashboardMode.active);
  
  const [rideRequestFields, setRideRequestFields] = useState(null);
  const [showCovidField, setShowCovidField] = useState(false);
  const [formikValues, setFormikValues] = useState(null);
  const [formIsValid, setFormIsValid] = useState(false);
  const [draftIsValid, setDraftIsValid] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  const navigate = Navigation();

  const transformedRideRequestFields = useMemo(() => {
    return HOPreferences ? transformRideRequestFields(HOPreferences.rideRequestFields) : null;
  }, [HOPreferences]);

  const costCenterField = useMemo(() => ({
    show: rideRequestFields?.some((field) => field.name === RIDE_REQUEST_FIELDS.costCenter),
    isRequired: rideRequestFields?.find((field) => field.name === RIDE_REQUEST_FIELDS.costCenter)?.value === MANDATORY_LEVEL.MANDATORY,
  }), [rideRequestFields]);

  const showAdditionalSourceField = useMemo(() => ({
    show: rideRequestFields?.some((field) => field.name === RIDE_REQUEST_FIELDS.additionalFundingSource),
    isRequired: rideRequestFields?.find((field) => field.name === RIDE_REQUEST_FIELDS.additionalFundingSource)?.value === MANDATORY_LEVEL.MANDATORY,
  }), [rideRequestFields]);

  const showDocumentReasonForRideField = useMemo(() => ({
    show: rideRequestFields?.some((field) => field.name === RIDE_REQUEST_FIELDS.documentReasonForRide),
    isRequired: rideRequestFields?.find((field) => field.name === RIDE_REQUEST_FIELDS.documentReasonForRide)?.value === MANDATORY_LEVEL.MANDATORY,
  }), [rideRequestFields]);

  const syncFormikValues = useCallback((values, isValid, path) => {
    setFormikValues(values);
    setFormIsValid(prev => ({ ...prev, [path]: isValid }));
  }, []);

  const handleShowDetailView = useCallback((draft) => {
     swtichToDetailView(draft);
 
  }, [navigate]);
 const handleCancel = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      setModalVisible(false);
      setIsClosing(false);
    }, 300);
  }, [setModalVisible]);
  const {
    handleDelete,
    handleStay,
    handlePreviousStep,
    handleSaveAndClose,
    handleSave,
    handleBack,
    handleLeave,
    handleSubmit,
    handleQuickSubmit,
    swtichToDetailView, 
  } = useCreateRideHandlers({
    Navigation: navigate,
    step,
    QuickScheduleModalVisible: handleCancel,
  });

 

  useEffect(() => {
    if (transformedRideRequestFields && !isEqual(rideRequestFields, transformedRideRequestFields)) {
      setRideRequestFields(transformedRideRequestFields);
    }
  }, [transformedRideRequestFields, rideRequestFields]);

  useEffect(() => {
    if (rideRequestFields) {
      setShowCovidField(rideRequestFields.some(field => field.name === RIDE_REQUEST_FIELDS.covid19Relation));
    }
  }, [rideRequestFields]);

  useEffect(() => {
    if (!HOPreferences) fetchHOPreferences();
      if (!platformPreferences) getPlatformSettings();
     if (!platformPreferences?.rideOptions) getAdditionalRideOptions();
  }, [HOPreferences, platformPreferences, fetchHOPreferences, getPlatformSettings, getAdditionalRideOptions]);

  return (
    <Modal
      visible={visibleModal}
      onCancel={handleCancel}
      closable
      width="auto"
       bodyStyle={{
        maxHeight: '90vh', // Set a maximum height for the modal content
        overflowY: 'auto', // Enable vertical scrolling
        padding: '10px', // Optional: Adjust padding for better appearance
            paddingRight: '40px',
      }}
      wrapClassName={`${styles.modalWrapper} ${isClosing ? styles.antModalSlideOut : ''}`}
      footer={null}
    >
      <QuickSchedule
        step={step}
        draft={draft}
        airportBufferTime={airportBufferTime}
        platformPreferences={platformPreferences}
        defaultTimeZone={defaultTimeZone}
        handleSave={handleSave}
        riderDetails={riderDetails}
        rideRequestFields={rideRequestFields}
        syncFormikValues={syncFormikValues}
        showCovidField={showCovidField}
        handleQuickSubmit={handleQuickSubmit}
        costCenterField={costCenterField}
        showAdditionalSourceField={showAdditionalSourceField}
        showDocumentReasonForRideField={showDocumentReasonForRideField}
        handleShowDetailView={handleShowDetailView}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  step: state.drafts.currentStep,
  draftId: state.drafts.draftId,
  draft: state.drafts.draft,
  riderDetails: state.riders.riderDetails,
  platformPreferences: state.preferences.platformPreferences,
  defaultTimeZone: state.authorization?.user?.preferredTimezone,
  HOPreferences: state.healthOrganizations.HOPreferences,
  rideOptions: state.preferences.rideOptions?.filter((option) => !option.disabled),
  userInactivityModalVisible: state.common.userInactivityModalVisible,
  airportBufferTime: state?.healthOrganizations?.HOPreferences?.airportBufferTime,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setCurrentStep,
  saveDraft,
  getPlatformSettings,
  fetchHOPreferences,
  getAdditionalRideOptions,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(QuickScheduleModal);